module.exports = __webpack_public_path__ + "img/flechas.4431d515.png";